import { Button } from '@components/Button/';
import EVImg from '@components/EVImg';
import DefaultEmbeddedForm from '@components/Forms/ContactForm/DefaultEmbeddedForm';
import Block from '@components/Layout/Block';
import RichText from '@components/RichText';
import { useTranslations } from 'next-intl';
import { FC, useState } from 'react';
import {
  BottomBlock,
  BottomEyebrow,
  BottomHeader,
  BottomText,
  BottomTextContainer,
  Container,
  GridLeftContainer,
  GridRightContainer,
  Header,
  ImageBox,
  SideTextContainer,
  Text,
} from './styles';

export interface StackedTextImageFormProps {
  imgFocalPoint: any;
  backgroundColor?: string;
  disclaimer?: string;
  reverse?: boolean;
  header: string;
  formHeader?: string;
  eyebrow?: string;
  ctaText: string;
  richText?: any;
  links?: any;
  formDescription?: any;
  chimeId: string;
  chimeType: string;
  className?: string;
}

const StackedTextImageForm: FC<StackedTextImageFormProps> = ({
  imgFocalPoint,
  backgroundColor,
  reverse,
  header,
  formHeader,
  eyebrow,
  ctaText,
  richText,
  links,
  formDescription,
  disclaimer,
  chimeId,
  chimeType,
  className,
}) => {
  const t = useTranslations();
  const [formSuccess, setFormSuccess] = useState<boolean | null>(null);

  return (
    <Block fullOnMobile className={className}>
      <Container $reverse={reverse}>
        <GridRightContainer data-testid="form-img-container">
          <ImageBox $ratio={[1.79]}>
            <EVImg dataTestId="form-img" imageFocalPointData={imgFocalPoint} />
          </ImageBox>
          <BottomTextContainer $backgroundColor={backgroundColor}>
            <BottomBlock>
              {eyebrow && (
                <BottomEyebrow data-testid="bottom-form-eyebrow" $backgroundColor={backgroundColor}>
                  {eyebrow}
                </BottomEyebrow>
              )}
              {header && <BottomHeader data-testid="bottom-form-header">{header}</BottomHeader>}
            </BottomBlock>
            <BottomBlock>
              {richText && (
                <BottomText data-testid="bottom-form-desc">
                  <RichText richText={richText} />
                </BottomText>
              )}
              {links &&
                links.map((link, index) => {
                  //check if the contentType is linkDownload
                  if (link?.sys?.contentType?.sys?.id === 'linkDownload') {
                    return (
                      <Button
                        variant={backgroundColor === 'cream' ? 'tertiaryBlack' : 'tertiaryWhite'}
                        label={link?.fields?.text}
                        url="#"
                        arrow={false}
                        icon="Download"
                        iconPosition="right"
                      />
                    );
                  } else {
                    return (
                      <div key={index}>
                        <Button
                          arrow={true}
                          variant={backgroundColor === 'cream' ? 'tertiaryBlack' : 'tertiaryWhite'}
                          url={link?.fields?.url}
                          label={link?.fields?.text}
                        />
                      </div>
                    );
                  }
                })}
            </BottomBlock>
          </BottomTextContainer>
        </GridRightContainer>
        <GridLeftContainer $reverse={reverse}>
          <SideTextContainer $isSent={formSuccess}>
            {formHeader && <Header data-testid="form-header">{formHeader.toUpperCase()}</Header>}
            {formDescription && (
              <Text data-testid="form-desc">
                <RichText richText={formDescription} />
              </Text>
            )}
          </SideTextContainer>
          <DefaultEmbeddedForm
            ctaText={ctaText}
            disclaimer={disclaimer ?? t('ContactForm.disclaimer')}
            setFormSuccess={setFormSuccess}
            chimeId={chimeId}
            chimeType={chimeType}
            isStackedImageForm={true}
          />
        </GridLeftContainer>
      </Container>
    </Block>
  );
};

export default StackedTextImageForm;
